<template>
  <div>
    <el-card>
      <el-steps :active="0" align-center finish-status="success" class="mb20">
        <el-step :title="$t('text.basicSettings')"></el-step>
        <el-step :title="$t('text.productManagement')"></el-step>
      </el-steps>
      <alter-form :customeButton="true" @handleAddFirstArray="afterAdd" :addFirstArray="true" :subFirstArray="true" @handleSubFirstArray="removeArray" :watchImageVisible="false" @handleChange="handleChange" ref="alterForm" @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength" @switchChanged="handleSwitchChange">
        <template v-slot:customeButton="data">
          <div class="margintop20">
            <el-button @click="handleCancelClick">{{ $t('button.cancel') }}</el-button>
            <el-button type="primary" @click="formSubmit(data)">{{ btnTxt }}</el-button>
          </div>
        </template>
      </alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineCouponEdit from './index.js'
export default onlineCouponEdit
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
